import { render, staticRenderFns } from "./Simulator.vue?vue&type=template&id=2542bdb0&scoped=true&"
import script from "./Simulator.vue?vue&type=script&lang=js&"
export * from "./Simulator.vue?vue&type=script&lang=js&"
import style0 from "./Simulator.vue?vue&type=style&index=0&id=2542bdb0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2542bdb0",
  null
  
)

export default component.exports